import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
	AppAside,
	AppBreadcrumb,
	AppFooter,
	AppHeader,
	AppSidebar,
	AppSidebarFooter,
	AppSidebarForm,
	AppSidebarHeader,
	AppSidebarMinimizer,
	AppSidebarNav,
} from '@coreui/react';

// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';

import * as actions from "../../Store/Actions";
import * as types from '../../Store/Actions/types';

import { connect } from "react-redux";
import alertify from "alertifyjs";
import { filterNavLinks } from "../../util/functions";

import { can } from '../../util/functions';

alertify.set('notifier', 'position', 'top-right');

class DefaultLayout extends Component {

	isAuthenticated = () => {
		return this.props.user !== null;
	};

	ability = (p, matchAll = false) => {
		let { permissions: prs } = this.props;
		return can(p, prs, matchAll);
	};

	componentDidMount() {
		let { dispatch, getAuthPermissions, user } = this.props;
		getAuthPermissions(user.accessToken, user.UserID).then(res => {
			const permissions = res.data.map(p => p.Name);
			dispatch({
				type: types.GET_AUTH_PERMISSIONS,
				payload: permissions
			});
		}).catch(this.errorHandler);
	}


	errorHandler = error => {
		const { response } = error;
		let errorTitle = 'Error';
		let errorString = error.toString();

		if (response) {
			errorTitle = 'Error ' + response.status + ' - ' + response.statusText;
			errorString = response.data.Message;
		}

		// for debugging remove use this line
		//alertify.alert(errorTitle,errorString);

		alertify.alert("Error", errorString)
	};

	render() {

		let { permissions } = this.props;

		if (permissions.length === 0) {
			return <p />;
		}

		let nav = filterNavLinks(navigation, permissions);

		return (

			<div className="app">
				<AppHeader fixed>
					<DefaultHeader history={this.props.history}  {...this.props} ability={this.ability}  />
				</AppHeader>
				<div className="app-body">
					<AppSidebar fixed display="lg">
						{/* <AppSidebarHeader /> */}
						{/* <AppSidebarForm /> */}
						<AppSidebarNav navConfig={nav} {...this.props} />
						{/* <AppSidebarFooter /> */}
						<AppSidebarMinimizer />
					</AppSidebar>
					<main className="main">
						{/* <AppBreadcrumb appRoutes={routes} /> */}
						<Container fluid>
							<Switch>
								{routes.map((route, idx) => {
									return route.component ? (
										<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => {
											if (this.isAuthenticated()) {
												console.log("Ability in Layout",this.ability);
												return <route.component {...props} {...this.props} alertify={alertify} errorHandler={this.errorHandler} ability={this.ability}  />
											}
											return <Redirect to='/login' />;
										}}
										/>
									)
										: (null);
								},
								)}
								<Redirect from="/" to="/dashboard" />
							</Switch>
						</Container>
					</main>
					<AppAside fixed hidden>
						<DefaultAside />
					</AppAside>
				</div>
				<AppFooter>
					<DefaultFooter />
				</AppFooter>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.auth.user,
		permissions: state.auth.permissions,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatch: dispatch,
		getAuthPermissions: (token, id) => actions.getUserPermissions(token, id)
	};
};


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DefaultLayout);
